<template>
  <div class="signIn signIn-wrapper">
    <sign-in />
  </div>
</template>

<script>
import { CactusEventBus } from '@cactus-web/authenticator';
import SignIn from '../_common/signIn';

export default {
  name: 'Login',
  components: { SignIn },
  created() {
    // if user is already authenticated, redirect to home route
    this.$getCurrentUser().then(response => {
      if (response.username) this.$router.replace({ path: 'home' });
    });

    // Listen on eventbus for signIn message and redirect to home page
    CactusEventBus.$on('authState', info => {
      this.$log.info('App.js::cactusAuthenticate():', info);
      switch (info) {
        case 'signedIn':
          this.$router.replace({ path: 'home' });
          break;
      }
    });
  }
};
</script>

<style lang="scss">
.signIn-wrapper {
  .cactus-web-authenticator {
    padding-top: 40px;
  }
}

.signIn {
  position: relative;
  z-index: 0;
}
</style>
